import { render, staticRenderFns } from "./AddMultiValue.vue?vue&type=template&id=2921ddee&scoped=true"
import script from "./AddMultiValue.vue?vue&type=script&lang=js"
export * from "./AddMultiValue.vue?vue&type=script&lang=js"
import style0 from "./AddMultiValue.vue?vue&type=style&index=0&id=2921ddee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921ddee",
  null
  
)

export default component.exports